import {useQuery} from '@apollo/react-hooks';

import type {
    GetRecentLeads as GetRecentLeadsQuery,
    GetRecentLeadsVariables as GetRecentLeadsQueryVariables,
    GetRecentLeads_search_quickResults_recentResultsByType_leads as RecentLeadType,
} from 'nutshell-graphql-types';

import GET_RECENT_LEADS from '../queries/get-recent-leads.graphql';

export const useGetRecentLeads = (): {
    isLoading: boolean;
    recentLeads: RecentLeadType[];
    refetch: () => Promise<any>;
} => {
    const {data, loading, refetch} = useQuery<GetRecentLeadsQuery, GetRecentLeadsQueryVariables>(
        GET_RECENT_LEADS,
        {
            fetchPolicy: 'cache-and-network',
            variables: {
                limit: 10,
            },
            notifyOnNetworkStatusChange: true,
        }
    );

    const recentLeads =
        data &&
        data.search &&
        data.search.quickResults &&
        data.search.quickResults.recentResultsByType &&
        data.search.quickResults.recentResultsByType.leads
            ? data.search.quickResults.recentResultsByType.leads
            : [];

    return {
        recentLeads,
        isLoading: loading,
        refetch,
    };
};
